import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { PagedPatientSpeciesRefDto, PatientSpeciesRefDto } from '../../dtos/patient-species-ref.dto';

@Injectable()
export class AppointmentPatientSpeciesLookupRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // Same GET /api/patients/{patientId} the patients feature's own datasource uses for its detail
  // page -- returns the full PatientDto, but PatientSpeciesRefDto only declares the narrow subset
  // of fields (ExternalId/SpeciesId) this feature actually reads, so the extra fields are simply
  // ignored by the type system. NOT an import from `@features/web/patients/...`, to keep feature
  // isolation intact (mirrors AppointmentClientLookupRemoteDatasource.getById).
  public getById(patientId: string): Observable<PatientSpeciesRefDto> {
    return this.http.get<PatientSpeciesRefDto>(`${this.apiUrl}${API_ENDPOINTS.patients.byId(patientId)}`);
  }

  // Batched variant of getById -- resolves multiple patients' species in a single request instead
  // of one HTTP call per patient id.
  public getByIds(patientIds: readonly string[]): Observable<PagedPatientSpeciesRefDto> {
    return this.http.get<PagedPatientSpeciesRefDto>(`${this.apiUrl}${API_ENDPOINTS.patients.byIds}`, {
      params: { ids: patientIds.join(',') },
    });
  }
}
